import _ from 'lodash'
import set from 'lodash/fp/set'
import { combineReducers } from 'redux'

import { getRiskLevel } from 'core/service/investment/risklevel'
import { SELECT_PRODUCT } from 'quick-quote/product-selection/actions'

import {
  ACCEPT_FOREIGN_INVESTMENT,
  ACCEPT_HIGHER_RISK_INVESTMENT,
  ANSWER_QUESTION,
  CALCULATE_RISK,
  RESET_ANSWERED_QUESTION,
  RESET_RISK_EVALUATED,
  SELECT_QUESTIONNAIRE,
  SELECT_RISK_LEVEL,
  SET_AGENT_COMMENT,
  UPDATE_QUESTIONNAIRE,
} from './actions'

const initialRiskLevelState = getRiskLevel()

const riskLevel = (state = initialRiskLevelState, action) => {
  switch (action.type) {
    case SELECT_RISK_LEVEL:
      return action.payload
    default:
      return state
  }
}

const initialRiskState = {
  value: 0,
  label: '',
  isEvaluated: false,
  description: '',
}
const riskEvaluated = (state = initialRiskState, action) => {
  switch (action.type) {
    case SELECT_PRODUCT:
    case RESET_RISK_EVALUATED:
      return initialRiskState
    case CALCULATE_RISK:
      return action.payload
    default:
      return state
  }
}

// const initialQuestionnaireState = getQuestionnaire()
// const initialQuestionnaireV2State = getQuestionnaireV2()

let questionnairesInitialState = []

const questionnaires = (state = questionnairesInitialState, action) => {
  switch (action.type) {
    case SELECT_PRODUCT:
      return questionnairesInitialState
    case RESET_ANSWERED_QUESTION:
      return state.map((q) => {
        return q.multipleChoice ? { ...q, selectedChoice: [] } : { ...q, selectedChoice: 0 }
      })
    case SELECT_QUESTIONNAIRE:
      return action.payload
    case UPDATE_QUESTIONNAIRE:
      questionnairesInitialState = _.cloneDeep(action.payload)
      return action.payload
    case ANSWER_QUESTION:
      const { index, value } = action.payload
      return set([index - 1, 'selectedChoice'], value)(state)
    default:
      return state
  }
}

const agentComment = (state = '', action) => {
  switch (action.type) {
    case SET_AGENT_COMMENT:
      return action.payload
    case RESET_ANSWERED_QUESTION:
    case RESET_RISK_EVALUATED:
      return ''
    default:
      return state
  }
}

const allowHigherRiskInvestment = (state = false, action) => {
  switch (action.type) {
    case ACCEPT_HIGHER_RISK_INVESTMENT:
      return !state
    case RESET_ANSWERED_QUESTION:
    case RESET_RISK_EVALUATED:
      return false
    default:
      return state
  }
}

const allowForeignInvestment = (state = false, action) => {
  switch (action.type) {
    case ACCEPT_FOREIGN_INVESTMENT:
      return !state
    case RESET_ANSWERED_QUESTION:
    case RESET_RISK_EVALUATED:
      return false
    default:
      return state
  }
}

export const reducer = combineReducers({
  riskLevel,
  riskEvaluated,
  questionnaires,
  agentComment,
  allowHigherRiskInvestment,
  allowForeignInvestment,
})
